module.exports = __webpack_public_path__ + "static/media/bg_banner.ff16607d.png";